import type { FeedItem, TodoTaskItem } from './types';
export type QuickView = 'working' | 'all' | 'mine' | 'blocked' | 'testing' | 'priority';
export const quickView = (value: string | null): QuickView =>
  ['working', 'mine', 'blocked', 'testing', 'priority'].includes(value ?? '')
    ? (value as QuickView)
    : 'all';
export const matchesQuickView = (task: TodoTaskItem, view: QuickView, userId?: number) => {
  if (view === 'all') return true;
  if (task.status === 'done') return false;
  if (view === 'working') return task.status === 'in_progress';
  if (view === 'mine') return task.userId === userId;
  if (view === 'blocked') return (task.blockedByOpen ?? 0) > 0;
  if (view === 'testing') return task.status === 'testing';
  return task.priority === 'high' || task.priority === 'urgent';
};
export function groupedActivity(items: FeedItem[]) {
  const groups = new Map<string, FeedItem[]>();
  for (const item of items) {
    const day = new Date(item.createdAt).toLocaleDateString('sk');
    const key = `${day}:${item.projectId}:${item.entityType}:${item.entityId}`;
    const rows = groups.get(key) ?? [];
    rows.push(item);
    groups.set(key, rows);
  }
  return [...groups.values()];
}
export const needsAttention = (item: FeedItem, userId?: number) =>
  item.actorUserId !== userId &&
  ((item.type === 'user.ping' && Number(item.entityId) === userId) ||
    (item.type === 'handoff.requested' && Number(item.payload.toUserId) === userId) ||
    (item.type === 'test.result' && ['fail', 'blocked'].includes(String(item.payload.status))));
